import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCodersrankComponent } from './simple-icons-codersrank.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCodersrankComponent ],
    exports:      [ SimpleIconsCodersrankComponent ],
    bootstrap:    []
})
export class SimpleIconsCodersrankModule {}
